/* 🤖 this file was generated by svg-to-ts */
export const siriusChatCenteredText: {
  name: 'chat_centered_text';
  data: string;
} = {
  name: 'chat_centered_text',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path d="M9 10.5h6A.75.75 0 1 0 15 9H9a.75.75 0 0 0 0 1.5Zm0 3h6a.75.75 0 1 0 0-1.5H9a.75.75 0 1 0 0 1.5Z" fill="currentColor"/><path d="M20.25 3.75H3.75a1.5 1.5 0 0 0-1.5 1.5v12a1.5 1.5 0 0 0 1.5 1.5h5.578l1.388 2.316a1.49 1.49 0 0 0 2.568 0l1.388-2.316h5.578a1.5 1.5 0 0 0 1.5-1.5v-12a1.5 1.5 0 0 0-1.5-1.5Zm0 13.5h-5.578a1.518 1.518 0 0 0-1.285.731L12 20.297l-1.387-2.316a1.508 1.508 0 0 0-1.285-.731H3.75v-12h16.5v12Z" fill="currentColor"/></svg>`
};
